// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"9ac24075","171":"5708126e","388":"98c9573f"}[chunkId] + ".chunk.js";
};